export default {
  allowConnectToDB: true,
  skipInQuickEditPanel: true,
};
